import { render, staticRenderFns } from "./QuestionPool.vue?vue&type=template&id=370a1bb6&scoped=true&"
import script from "./QuestionPool.vue?vue&type=script&lang=js&"
export * from "./QuestionPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a1bb6",
  null
  
)

export default component.exports